<ng-container *transloco="let t">
  <p-overlaybadge
    (click)="menu.toggle($event)"
    severity="success"
    value="{{ unReadCount() }}"
    size="small"
    styleClass="cursor-pointer"
  >
    <p-button
      severity="secondary"
      [icon]="icons.bell"
      aria-label="notifications"
      [rounded]="true"
      class="relative"
    />
  </p-overlaybadge>

  <p-menu
    appendTo="body"
    #menu
    popup="true"
    styleClass="md:w-64 shadow-lg border border-gray-200 rounded-lg bg-white"
  >
    <ng-template pTemplate="start">
      <div class="p-3 flex items-center justify-between">
        <span class="font-semibold">{{ t('shared/notifications') }}</span>
        @if (unReadCount() > 0) {
        <button (click)="markAllAsRead()" class="text-xs text-primary">
          {{ t('shared/markAllAsRead') }}
        </button>
        }
      </div>

      <div class="max-h-60 overflow-y-auto">
        @for (notification of notifications(); track notification) {
        <div
          class="p-3 border-b transition mb-1"
          [ngStyle]="{
            'background-color': notification.isRead ? '' : '#007bff2b'
          }"
        >
          <div class="flex items-center gap-3">
            <i
              class="text-lg"
              [ngClass]="icons.bell"
              [ngStyle]="{ color: notification.isRead ? '#aaa' : '#007bff' }"
            ></i>
            <div class="flex-1">
              <div class="text-sm font-medium">
                {{ notification.message }}
              </div>
              <div class="text-xs">
                {{ notification.createdAt | date }}
              </div>
            </div>
          </div>
        </div>
        }
      </div>

      <div class="p-3 flex justify-center">
        <a
          [routerLink]="routerLinks.notifications()"
          class="w-full text-sm text-center text-primary"
          (click)="menu.hide()"
          >{{ t('shared/showMore') }}</a
        >
      </div>
    </ng-template>
  </p-menu>
</ng-container>
